import React from 'react';

import Filters from '../../common/Filters/Filters';

interface Props {
  filters: Record<string, string>;
  setFilter: (filter: string, value: string) => void;
}

const TeachersFilters = ({ filters, setFilter }: Props) => (
  <Filters
    className="d-flex flex-column gap-3 align-items-stretch"
    values={filters}
    setFilter={setFilter}
    filtersSchema={{
      username: { type: 'input', placeholder: 'Имя пользователя' },
      school: { type: 'input', placeholder: 'Школа' },
    }}
  />
);

export default TeachersFilters;
